//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PayrollType } from './Enums';

export abstract class PayrollUpdateItem extends ItemBase {
    PayrollType?: PayrollType;
    Date?: string;
    Amount?: number;
    Comment?: string | null;

    static readonly ClassName: string = "PayrollUpdateItem";
}
